export enum PlatformRouteNames {
  Login = 'platform-login',
  Activity = 'platform-activity',
  Analytics = 'platform-analytics',
  BusinessView = 'platform-business-view',
  Crm = 'platform-crm',
}
